module.exports = __webpack_public_path__ + "static/media/service4.82de42aa.JPG";